import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function Splash({ onComplete }) {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    // Simulate loading with progress
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer)
          // Complete splash after a brief moment
          setTimeout(() => onComplete(), 500)
          return 100
        }
        return prev + 20 // 5 steps to complete
      })
    }, 400)

    return () => clearInterval(timer)
  }, [onComplete])

  return (
    <div className="splash-screen">
      <div className="splash-content">
        {/* Branding */}
        <div className="app-logo">
          <img
            src="./assets/logo.png"
            alt="WAYFARE Logo"
            style={{
              width: '180px',
              height: '180px',
              borderRadius: '8px',

              objectFit: 'cover'
            }}
          />
        </div>
        <h1 className="app-title" style={{ fontFamily: "'Noto Serif', serif", textTransform: 'uppercase', letterSpacing: '2px' }}>{t('splash.appTitle')}</h1>
        <p className="app-tagline">{t('splash.tagline')}</p>

        {/* Value Proposition */}
        <div className="value-proposition">
          <p>{t('splash.features.memories')}</p>
          <p>{t('splash.features.planning')}</p>
          <p>{t('splash.features.timeline')}</p>
          <p>{t('splash.features.offline')}</p>
        </div>

        {/* Loading Progress */}
        <div className="loading-section">
          <div className="loading-bar">
            <div 
              className="loading-progress" 
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="loading-text">
            {progress < 20 && t('splash.loading.initializing')}
            {progress >= 20 && progress < 40 && t('splash.loading.loadingData')}
            {progress >= 40 && progress < 60 && t('splash.loading.settingUpChallenges')}
            {progress >= 60 && progress < 80 && t('splash.loading.preparingJourney')}
            {progress >= 80 && progress < 100 && t('splash.loading.almostReady')}
            {progress === 100 && t('splash.loading.welcome')}
          </p>
        </div>

        {/* Footer */}
        <div className="splash-footer">
          <p><span style={{ fontFamily: "'Noto Serif', serif", textTransform: 'uppercase', letterSpacing: '1px' }}>{t('splash.appTitle')}</span> {t('splash.tagline')}</p>
          <p>{t('splash.footer')}</p>
        </div>
      </div>
    </div>
  )
}